import { useAppSelector } from '../../app/hooks';
import { useGetMyTreeQuery } from './organizationsApi';

/**
 * The effective active organization id — the one picked in the header, falling
 * back to the signed-in admin's own org. This is the common org every screen
 * should read (sidebar departments, listings scoped by org, etc.).
 */
export function useActiveOrgId(): number | undefined {
  const selected = useAppSelector((s) => s.activeOrg.selectedOrgId);
  const { data: myTree } = useGetMyTreeQuery();
  return selected ?? myTree?.organization ?? undefined;
}
